<template>
  <span class="svg-icon-arrow-chevron-up">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.8025 15.2799C19.5096 15.5728 19.0347 15.5728 18.7418 15.2799L12.8717 9.41054C12.3946 8.93344 11.6094 8.93344 11.1323 9.41054L5.26255 15.2803C4.96966 15.5732 4.49479 15.5732 4.20189 15.2803C3.909 14.9874 3.909 14.5126 4.20189 14.2197L10.0717 8.34988C11.1346 7.28699 12.8694 7.28699 13.9323 8.34988L19.8025 14.2193C20.0954 14.5122 20.0954 14.987 19.8025 15.2799Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } },
    isSolid: { type: Boolean },
  }
}
</script>